<script>
export default {
  name: 'USDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5576 14.8208C13.5576 14.367 13.4303 14.0073 13.1758 13.7417C12.9268 13.4705 12.5007 13.2215 11.8975 12.9946C11.2943 12.7677 10.7741 12.5436 10.3369 12.3223C9.89974 12.0954 9.52344 11.8381 9.20801 11.5503C8.89811 11.257 8.65462 10.9139 8.47754 10.521C8.30599 10.1281 8.22021 9.66048 8.22021 9.11816C8.22021 8.18294 8.51904 7.4165 9.1167 6.81885C9.71436 6.22119 10.5085 5.87256 11.499 5.77295V4.66064C11.499 4.29389 11.7963 3.99658 12.1631 3.99658V3.99658C12.5298 3.99658 12.8271 4.29389 12.8271 4.66064V5.79785C13.8066 5.9362 14.5731 6.3457 15.1265 7.02637C15.4987 7.48052 15.7458 8.02609 15.8676 8.66305C15.9714 9.2055 15.5088 9.65771 14.9565 9.65771H14.5576C14.0053 9.65771 13.597 9.19434 13.4178 8.67195C13.3504 8.47555 13.2587 8.30886 13.1426 8.17188C12.8714 7.83984 12.5062 7.67383 12.0469 7.67383C11.5931 7.67383 11.2417 7.80387 10.9927 8.06396C10.7437 8.31852 10.6191 8.67269 10.6191 9.12646C10.6191 9.54704 10.7409 9.8846 10.9844 10.1392C11.2279 10.3937 11.6789 10.6538 12.3374 10.9194C13.0015 11.1851 13.5465 11.4368 13.9727 11.6748C14.3988 11.9072 14.7585 12.1729 15.0518 12.4717C15.3451 12.765 15.5692 13.1025 15.7241 13.4844C15.8791 13.8607 15.9565 14.3006 15.9565 14.8042C15.9565 15.745 15.6632 16.5086 15.0767 17.0952C14.4901 17.6818 13.6821 18.0277 12.6528 18.1328V19.1248C12.6528 19.4892 12.3574 19.7847 11.9929 19.7847V19.7847C11.6285 19.7847 11.333 19.4892 11.333 19.1248V18.1411C10.1986 18.0194 9.31868 17.6182 8.69336 16.9375C8.26654 16.4649 7.98668 15.8861 7.85379 15.201C7.74863 14.6588 8.21139 14.2065 8.76367 14.2065H9.1626C9.71488 14.2065 10.1251 14.6713 10.3156 15.1897C10.3914 15.396 10.4953 15.5746 10.6274 15.7256C10.9429 16.0742 11.3939 16.2485 11.9805 16.2485C12.4674 16.2485 12.8521 16.1213 13.1343 15.8667C13.4165 15.6066 13.5576 15.258 13.5576 14.8208Z"
      :fill="color"
    />
  </svg>
</template>
